import http from 'hub-http/clients/apiClient';
export const getProductInfo = () => http.get('/app-users/v1/sales-products/product-info');